/**
 * LogIn — the login dialog. Shown when the app finds no session (ui/AppLayout calls
 * setShowLogIn(true) when auth === false). Cannot be dismissed without logging in.
 *
 * logIn(password, username) → POST /api/logIn; 'err' → toast "לא הצליח להכנס".
 * Enter in either field submits. Logic unchanged from the pre-redesign version.
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import * as actionsCreators from './../../actions/index.js';
import { Modal, Button, Input } from '../../ui';
import classes from './logIn.css';

const LogIn = (props) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setUsername('');
    setPassword('');
    props.setShowLogIn(false);
  };

  const onLogInHandler = async () => {
    setLoading(true);
    const res = await props.logIn(password, username);
    setLoading(false);
    if (res === 'err') props.showAlert('לא הצליח להכנס');
    else handleClose();
  };

  return (
    <Modal
      open={props.showLogIn}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      width={380}
      centered
      zIndex={1111}
    >
      <div className={classes.card}>
        <img src="/assets/logo.png" alt="logo" className={classes.logo} />
        <h2 className={classes.title}>כניסה ל-TalsCRM</h2>
        <Input
          size="large"
          prefix={<UserOutlined />}
          placeholder="שם משתמש"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onPressEnter={onLogInHandler}
        />
        <Input.Password
          size="large"
          prefix={<LockOutlined />}
          placeholder="סיסמה"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onPressEnter={onLogInHandler}
        />
        <Button type="primary" size="large" block loading={loading} onClick={onLogInHandler}>
          התחבר
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    showLogIn: state.ShowModels.showLogIn,
  };
};

export default connect(mapStateToProps, actionsCreators)(LogIn);
